'use strict';
var $ = require('jquery');

function init() {
	// Sending flag - set during AJAX request
	var sending = false;

	var config = {
		buttonSelector: ".adminResultsRow__bookmarksLink",
		dataAttribute: "data-bookmark-link",
		parentElement: "tr",
		tableSelector: "#adminResultsList",
		// accordionPanelClass: "adminResultsBookmarks",
		// accordionPanelInnerClass: "adminResultsBookmarks__inner",
		bookmarkRowClass: "adminResultsRow--bookmark",
		bookmarkRowExpandedClass: "adminResultsRow--bookmarkExpanded",
		loadingSelector: "adminResultsRow--bookmarksLoading",
		loadedSelector: "adminResultsRow--bookmarksLoaded",
		expandedSelector: "adminResultsRow--bookmarksExpanded"
	};

	$("main").on("click", config.buttonSelector, function(){
		if (sending) {
			return;
		}

		var $elem = $(this);
		var parentTr = $elem.parents(config.parentElement);
		var elem = $elem[0];
		var link = loadAttribute(elem, config.dataAttribute);

		if (!parentTr.hasClass(config.loadedSelector)) {
			sendRequest(link, parentTr, function(response){
				var tbody = $(response).find(config.tableSelector);
				if (tbody.length > 0) {
					// I'd like to do the following (add a wrapper around the bookmark rows) so we can transition the expansion of the accordion
					// We cannot do it because the columns in the parent and child table won't line up
					// parentTr.after('<tr class="' + config.accordionPanelClass + '"><td colspan="10"><div class="' + config.accordionPanelInnerClass + '"><table>' + tbody.html() + '</table></div></td></tr>');
					
					tbody.find('tr').addClass(`${config.bookmarkRowClass} ${config.bookmarkRowExpandedClass}`);
					parentTr.after(tbody.html());
				}
			});
		}

		if (parentTr.hasClass(config.loadedSelector)) {
			if (parentTr.hasClass(config.expandedSelector)) {
				parentTr.removeClass(config.expandedSelector);
				parentTr.nextUntil('.adminResultsRow:not(.adminResultsRow--bookmark)').removeClass(config.bookmarkRowExpandedClass);
			} else {
				parentTr.addClass(config.expandedSelector);
				parentTr.nextUntil('.adminResultsRow:not(.adminResultsRow--bookmark)').addClass(config.bookmarkRowExpandedClass);
			}
		}
	});

	function sendRequest(link, parentTr, callback) {
		parentTr.addClass(config.loadingSelector);
		sending = true;
		$.ajax({ url: link, dataType: "html"}).done(function (response) {
			callback(response);
		}).always(function () {
			sending = false;
			parentTr.removeClass(config.loadingSelector);
			parentTr.addClass(config.loadedSelector);
			parentTr.addClass(config.expandedSelector);
		});
	}

	function loadAttribute(elem, attributeName) {
		return elem.hasAttribute(attributeName) ? elem.getAttribute(attributeName) : false;
	}
}

module.exports = {
	init: init
}

